import {
  SET_CURRENTEXAM
}
  from './mutation-type'


const mutations = {
  [SET_CURRENTEXAM] (state, {data}) {
    state.currentExam = data;
  },
}

export default mutations